import React from 'react';
import CountUp from 'react-countup';
import '../stylesheets/counter.scss';



class Counter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      delay: 3600,
      redraw: true
    };
  }
  componentDidMount() {
    window.addEventListener('scroll', this.handleCounter);
  }

  handleCounter = () => {
    if (window.scrollY >= 85) {
      this.setState({
        delay: 0,
        redraw: false
      })
    }
  }


  render() {
    let options = this.props.options;
    return (
      <div className='container-counter-home'>
        <div className='counter-home'>
          <div className='counter-home-flex'>
            {
              options.map((element, index) => (
                <div
                  key={index}
                  className='counter-home-item'>
                  <div className='icon-container'>
                    <i>{element.icon}</i>
                  </div>
                  <div className='counter'>
                    <h2
                      className='counter-number'
                    >
                      <CountUp
                        start={0}
                        end={element.count}
                        delay={this.state.delay}
                        duration={2.75}
                        separator='.'
                        redraw={this.state.redraw}
                      />
                    </h2>
                    <p className='counter-title'>
                      {element.item}
                    </p>
                  </div>
                </div>
              ))
            }
          </div>
        </div>
      </div>
    )
  }
}

export default Counter;
